import Nullstack from 'nullstack';
export default function IconBallBaseball({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ball-baseball",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728z"
  }), "   ", Nullstack.element("path", {
    d: "M12.495 3.02a9 9 0 0 1 -9.475 9.475"
  }), "   ", Nullstack.element("path", {
    d: "M20.98 11.505a9 9 0 0 0 -9.475 9.475"
  }), "   ", Nullstack.element("path", {
    d: "M9 9l2 2"
  }), "   ", Nullstack.element("path", {
    d: "M13 13l2 2"
  }), "   ", Nullstack.element("path", {
    d: "M11 7l2 1"
  }), "   ", Nullstack.element("path", {
    d: "M7 11l1 2"
  }), "   ", Nullstack.element("path", {
    d: "M16 11l1 2"
  }), "   ", Nullstack.element("path", {
    d: "M11 16l2 1"
  }), " ");
}